import { useState } from 'react';

const useConfirmation = () => {
  const [confirmation, setConfirmation] = useState({
    isOpen: false,
    title: '',
    message: '',
    confirmText: 'Confirmar',
    cancelText: 'Cancelar',
    type: 'warning',
    showCancel: true,
    onConfirm: null,
    onCancel: null
  });

  const showConfirmation = ({
    title = 'Confirmar Ação',
    message,
    messidade,
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
    type = 'warning',
    showCancel = true
  }) => {
    const resolvedMessage =
      message ?? messidade ?? 'Tem certeza que deseja continuar?';
    return new Promise((resolve) => {
      setConfirmation({
        isOpen: true,
        title,
        message: resolvedMessage,
        confirmText,
        cancelText,
        type,
        showCancel,
        onConfirm: () => {
          hideConfirmation();
          resolve(true);
        },
        onCancel: () => {
          hideConfirmation();
          resolve(false);
        }
      });
    });
  };

  const hideConfirmation = () => {
    setConfirmation(prev => ({
      ...prev,
      isOpen: false
    }));
  };

  const confirmAction = () => {
    if (confirmation.onConfirm) {
      confirmation.onConfirm();
    }
  };

  const cancelAction = () => {
    if (confirmation.onCancel) {
      confirmation.onCancel();
    }
  };

  return {
    confirmation,
    showConfirmation,
    hideConfirmation,
    confirmAction,
    cancelAction
  };
};

export default useConfirmation;





















